import React from 'react';


function CardSkillsRow({ stack }) {

    return (
        <div className="row text-center skills-card">
            {stack.obj.map((item, index) => {
                return <div key={index} className="col m2 skills-icon">
                    <img alt="" src={item.imgUrl} className="responsive-img" />
                    <p className="responsive-text">{item.stack}</p>
                </div>
            }
            )}
        </div>
    )
}


export default CardSkillsRow;
